/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum StackNumberingEnumDto {
    AUTO_GENERATED = 'AutoGenerated',
    MANUEL = 'Manuel',
}